module.exports = __webpack_public_path__ + "img/32.8c05013b.png";